import { motion } from 'framer-motion';
import useGameStore from '@/store/gameStore';
import LobbyPhase from './phases/LobbyPhase';
import WritingPhase from './phases/WritingPhase';
import ReviewPhase from './phases/ReviewPhase';
import GuessingPhase from './phases/GuessingPhase';
import ScoringPhase from './phases/ScoringPhase';
import GameOverPhase from './phases/GameOverPhase';

function GameBoard() {
  const { gameState } = useGameStore();

  if (!gameState) return null;

  const renderPhase = () => {
    switch (gameState.phase) {
      case 'LOBBY':
        return <LobbyPhase />;
      case 'ROUND_SETUP':
        return (
          <div className="text-center py-12">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
              className="inline-block text-4xl mb-4"
            >
              ⚙️
            </motion.div>
            <p className="text-lg text-gray-600">Setting up round {gameState.round?.number}...</p>
          </div>
        );
      case 'WRITING':
        return <WritingPhase />;
      case 'REVIEW':
        return <ReviewPhase />;
      case 'GUESSING':
        return <GuessingPhase />;
      case 'SCORING':
        return <ScoringPhase />;
      case 'GAME_OVER':
        return <GameOverPhase />;
      default:
        return <div>Unknown phase: {gameState.phase}</div>;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="card min-h-[400px]"
      data-testid="game-board"
    >
      {renderPhase()}
    </motion.div>
  );
}

export default GameBoard;
